// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { ToggleSwitchState } from '../data/utils/types';

type ToggleSwitchProps = {
  onSwitchClick?: (state: ToggleSwitchState) => void;
  page: string;
};


function ToggleSwitch(props: ToggleSwitchProps) {

  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const handleClick = (state: ToggleSwitchState) => {
    if (props.onSwitchClick) {
      props.onSwitchClick(state);
    }
  };

  return (
    <>
      {(props.page == "all-accounts" || props.page == "active-accounts") &&
        <div style={{ border: '1px solid #ff7300', borderRadius: 25, height: '49.5px', width: 'fit-content' }}>
          <Tabs
            sx={{
              justifyContent: 'flex-start', "& button": { borderRadius: 10, boxShadow: 'insert', zIndex: 1 },
              "& button.Mui-selected": { color: '#fff' }
            }}
            value={value}
            onChange={handleChange}

            TabIndicatorProps={{ sx: { backgroundColor: '#ff7300', height: '100%', borderRadius: 10 } }}
          >
            <Tab onClick={() => handleClick("active-accounts")} label="Active Accounts" />
            <Tab onClick={() => handleClick("all-accounts")} label="All Accounts" />
          </Tabs>
        </div>
      }

      {props.page === "projects" &&
        <Tabs
          sx={{ justifyContent: 'flex-start', "& button": { borderRadius: 10, zIndex: 1 }, "& button.Mui-selected": { color: '#fff' } }}
          value={0}
          TabIndicatorProps={{ sx: { backgroundColor: '#ff7300', height: '100%', borderRadius: 10 } }}
        >
          <Tab label="All Projects" disabled />
        </Tabs>}
    </>
  );
};

export default ToggleSwitch;
